import React, { useEffect, useState } from "react";
import Markdown from "markdown-to-jsx";
import styles from "../../layouts/DashboardLayout/DashboardLayout.module.css";

export default function PrivacyPolicy() {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/docs/privacy-policy.md")
      .then((res) => res.text())
      .then(setContent)
      .catch(console.log);
  }, []);

  const markdownOptions = {
    overrides: {
      h1: { props: { style: { color: "#000000ff", textAlign: "center", fontSize: "2em", marginTop: "1em", marginBottom: "0.5em" } } },
      h2: { props: { style: { color: "#000000ff", fontSize: "1.5em", marginTop: "1em", marginBottom: "0.5em" } } },
      h3: { props: { style: { color: "#000000ff", fontSize: "1.2em", marginTop: "1em", marginBottom: "0.5em" } } },
      p: { props: { style: { lineHeight: 1.5, marginBottom: "1em" } } },
      ul: { props: { style: { paddingLeft: "1.5em", marginBottom: "1em", listStyleType: "disc" } } },
      ol: { props: { style: { paddingLeft: "1.5em", marginBottom: "1em", listStyleType: "decimal" } } },
      li: { props: { style: { marginBottom: "0.5em" } } },
      strong: { props: { style: { fontWeight: "bold" } } },
      em: { props: { style: { fontStyle: "italic" } } },
      a: { props: { style: { color: "#000000ff", textDecoration: "underline" } } },
    },
  };

  return (
    <div style={{ padding: '0px 100px' }} >
      <div style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 10 }}>
        <h2
          style={{
            textAlign: "center",
            color: "#424242",
            margin: 0,
            fontSize: "25px",
            padding: "20px 0",
          }}
        >
          Privacy Policy
        </h2>
        <div style={{ height: "1px", backgroundColor: "#666", width: "100%" }}></div>
      </div>


      <div style={{ paddingTop: "5px", color: "#424242" }}>
        <Markdown options={markdownOptions}>{content}</Markdown>
      </div>
       <div className={styles.footer}>
        <span className="powered">Powered by Warely</span>
      </div>
    </div>
  );
}
